import { render, staticRenderFns } from "./DTlist.vue?vue&type=template&id=6adb27da&scoped=true"
import script from "./DTlist.vue?vue&type=script&lang=js"
export * from "./DTlist.vue?vue&type=script&lang=js"
import style0 from "./DTlist.vue?vue&type=style&index=0&id=6adb27da&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adb27da",
  null
  
)

export default component.exports